"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for subscription service
 * @param {string} message the validation message
 */
class CustomerIdDoesNotExistForUserInDBError extends client_library_1.ExtendableError {
    constructor() {
        super('CustomerIdDoesNotExistForUserInDB');
    }
}
exports.default = CustomerIdDoesNotExistForUserInDBError;
//# sourceMappingURL=CustomerIdDoesNotExistForUserInDBError.js.map